import React, { useEffect, useRef } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { google_login_thunk } from "../redux/auth/authThunk";
import { setErrorAlert } from "../redux/alert/alertSlice";
import { motion, useAnimation } from "framer-motion";
import axios from "axios";
let REACT_APP_GOOGLE_CLIENT_ID = `551543461519-oc0leh05gmltefj8q42u10603aoqbu4i.apps.googleusercontent.com`;
const ParticleBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];

    for (let i = 0; i < 100; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 2 + 1,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5,
      });
    }

    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => {
        particle.x += particle.vx;
        particle.y += particle.vy;

        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
        ctx.fill();
      });
    }

    animate();

    return () => {
      // Cleanup if needed
    };
  }, []);

  return <canvas ref={canvasRef} className="absolute inset-0 z-0" />;
};

const FlashlightEffect = () => {
  const flashlightRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (flashlightRef.current) {
        const rect = flashlightRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        flashlightRef.current.style.background = `radial-gradient(circle at ${x}px ${y}px, transparent 0%, rgba(0,0,0,0.95) 50%)`;
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      ref={flashlightRef}
      className="absolute inset-0 z-10 pointer-events-none"
    />
  );
};

export default function ReactLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      opacity: [0, 1],
      transition: { duration: 1 },
    });
  }, [controls]);

  // const getTimeZone = () => {
  //   return Intl.DateTimeFormat().resolvedOptions().timeZone;
  // };

  // const getIp = async () => {
  //   const response = await fetch("https://api.ipify.org?format=json");
  //   const data = await response.json();
  //   console.log("data", data);
  //   return data;
  // };

  const handleGoogleUserData = async (response) => {
    let userData = jwtDecode(response.credential);

    // const timeZone = getTimeZone();
    // const ip = await getIp();
    let data = {
      firstName: userData.given_name,
      lastName: userData.family_name,
      email: userData.email,
      image: userData.picture,
      // timeZone: timeZone,
      // ip: ip,
    };
    dispatch(google_login_thunk({ data })).then((res) => {
      navigate("");
    });
  };
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const handleError = (response) => {
    setErrorAlert("Google Login Failed");
  };
  return (
    <motion.div
      className="relative min-h-screen w-screen flex items-center justify-center bg-gradient-to-r from-gray-900 to-gray-300 overflow-hidden"
      initial={{ opacity: 0 }}
      animate={controls}
    >
      <ParticleBackground />
      <FlashlightEffect />

      <div className="relative z-20">
        <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>
          <motion.div
            className="relative overflow-hidden rounded-full shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-gray-400 to-white opacity-75"
              animate={{
                rotate: [0, 360],
              }}
              transition={{
                duration: 10,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <GoogleLogin
              onSuccess={handleGoogleUserData}
              onError={handleError}
              shape="pill"
              size="large"
              theme="filled_black"
              text="sign_in_with"
              useOneTap
            />
          </motion.div>
        </GoogleOAuthProvider>
      </div>
    </motion.div>
  );
}

// sample >> 2

// import React, { useEffect, useRef } from "react";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// import { GoogleLogin } from "@react-oauth/google";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import { google_login_thunk } from "../redux/auth/authThunk";
// import { setErrorAlert } from "../redux/alert/alertSlice";
// import { motion, useAnimation } from "framer-motion";
// import axios from "axios";
// let REACT_APP_GOOGLE_CLIENT_ID = `551543461519-oc0leh05gmltefj8q42u10603aoqbu4i.apps.googleusercontent.com`;

// const Beam = ({ angle, width, delay, duration, opacityStart, opacityEnd, length }) => (
//   <motion.div
//     className="absolute top-0 left-0 w-full h-full origin-bottom"
//     style={{
//       transform: `rotate(${angle}deg)`,
//       background: `linear-gradient(to top, rgba(255,255,255,${opacityStart}) 0%, rgba(255,255,255,${opacityEnd}) 50%, rgba(255,255,255,${opacityStart}) 100%)`,
//       width: `${width}px`,
//       height: `${length}px`,
//     }}
//     animate={{
//       opacity: [opacityStart, opacityEnd, opacityStart],
//       height: ["0%", "100%", "0%"],
//     }}
//     transition={{
//       duration: duration,
//       ease: "easeInOut",
//       times: [0, 0.5, 1],
//       repeat: Infinity,
//       delay: delay,
//     }}
//   />
// );
// const movingLightVariants = {
//   animate: {
//     boxShadow: [
//       '0 0 10px rgba(255, 255, 255, 0.6)', // starting glow
//       '0 0 20px rgba(255, 255, 255, 0.9)', // medium glow
//       '0 0 30px rgba(255, 255, 255, 1)',   // strong glow
//       '0 0 10px rgba(255, 255, 255, 0.6)', // fade back
//     ],
//     transition: {
//       duration: 2,
//       repeat: Infinity,  // Repeat animation indefinitely
//       repeatType: 'loop', // Loop the animation
//       ease: 'easeInOut',
//     },
//   },
// };

// const FlashlightButton = ({ children }) => {
//   const buttonRef = useRef(null);
//   const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });

//   useEffect(() => {
//     const handleMouseMove = (e) => {
//       if (buttonRef.current) {
//         const rect = buttonRef.current.getBoundingClientRect();
//         setMousePosition({
//           x: e.clientX - rect.left,
//           y: e.clientY - rect.top,
//         });
//       }
//     };

//     if (buttonRef.current) {
//       buttonRef.current.addEventListener("mousemove", handleMouseMove);
//     }

//     return () => {
//       if (buttonRef.current) {
//         buttonRef.current.removeEventListener("mousemove", handleMouseMove);
//       }
//     };
//   }, []);

//   return (
//     <motion.div
//       ref={buttonRef}
//       className="relative overflow-hidden rounded-full"
//       whileHover={{ scale: 1.05 }}
//       whileTap={{ scale: 0.95 }}
//     >
//       <div
//         className="absolute inset-0 pointer-events-none"
//         style={{
//           background: `radial-gradient(circle 100px at ${mousePosition.x}px ${mousePosition.y}px, rgba(255,255,255,0.3), transparent 100%)`,
//         }}
//       />
//       {children}
//     </motion.div>
//   );
// };

// export default function ReactLogin() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const controls = useAnimation();

//   useEffect(() => {
//     controls.start({
//       opacity: 1,
//       transition: { duration: 1.5, ease: "easeOut" },
//     });
//   }, [controls]);

//   // const getTimeZone = () => {
//   //   return Intl.DateTimeFormat().resolvedOptions().timeZone;
//   // };

//   // const getIp = async () => {
//   //   const response = await fetch("https://api.ipify.org?format=json");
//   //   const data = await response.json();
//   //   console.log("data", data);
//   //   return data;
//   // };

//   const handleGoogleUserData = async (response) => {
//     let userData = jwtDecode(response.credential);
//     console.log("userData", userData);

//     // const timeZone = getTimeZone();
//     // const ip = await getIp();
//     let data = {
//       firstName: userData.given_name,
//       lastName: userData.family_name,
//       email: userData.email,
//       image: userData.picture,
//       // timeZone: timeZone,
//       // ip: ip,
//     };
//     dispatch(google_login_thunk({ data })).then((res) => {
//       navigate("");
//     });
//   };
//   const textVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0 },
//   };

//   const handleError = (response) => {
//     setErrorAlert("Google Login Failed");
//   };
//   return (
//     <motion.div
//     className="relative min-h-screen w-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-gray-800 overflow-hidden"
//     initial={{ opacity: 0 }}
//     animate={controls}
//   >
//     {[15, 45, 75, 105, 135, 165].map((angle, index) => (
//       <Beam
//         key={angle}
//         angle={angle}
//         width={3 + index}
//         delay={index * 0.3}
//         duration={7 + index}
//         opacityStart={0.05 + index * 0.02}
//         opacityEnd={0.2 + index * 0.1}
//         length={Math.random() * (1000 - 600) + 600}
//       />
//     ))}

// <motion.div
//     className="relative z-10 p-12 bg-gray-800 bg-opacity-30 rounded-2xl backdrop-filter backdrop-blur-lg shadow-2xl"
//     variants={movingLightVariants}
//     animate="animate"
//   >
//     <motion.h1
//       className="text-5xl font-bold text-white mb-6 text-center"
//       variants={textVariants}
//       initial="hidden"
//       animate="visible"
//       transition={{ delay: 0.5, duration: 0.8 }}
//     >
//       Welcome to todo
//     </motion.h1>
//     <motion.p
//       className="text-xl text-gray-300 mb-10 text-center"
//       variants={textVariants}
//       initial="hidden"
//       animate="visible"
//       transition={{ delay: 0.7, duration: 0.8 }}
//     >
//       Sign in to access your account
//     </motion.p>
//     <motion.div
//       initial={{ scale: 0.8, opacity: 0 }}
//       animate={{ scale: 1, opacity: 1 }}
//       transition={{ delay: 1, duration: 0.5 }}
//     >
//       <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>
//         <FlashlightButton>
//           <GoogleLogin
//             onSuccess={handleGoogleUserData}
//             onError={handleError}
//             shape="pill"
//             size="large"
//             theme="filled_black"
//             text="sign_in_with"
//             useOneTap
//           />
//         </FlashlightButton>
//       </GoogleOAuthProvider>
//     </motion.div>
//   </motion.div>

//   </motion.div>
//   );
// }
